export const CloseIcon = () => (
  <svg width='27' height='27' viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='13.5' cy='13.5' r='13.5' fill='current' />
    <rect
      x='7.42969'
      y='8.10059'
      width='1.35'
      height='16.2'
      transform='rotate(-45 7.42969 8.10059)'
      fill='white'
    />
    <rect
      x='18.9023'
      y='7.42529'
      width='1.35'
      height='16.2'
      transform='rotate(45 18.9023 7.42529)'
      fill='white'
    />
  </svg>
)
